import agent from './agent';
import config from '../config.json';
import ServiceBase from './ServiceBase';

const baseUrl = config.baseUrl;
const service = 'jernytibber';

class PowerScheduleService extends ServiceBase {
    /**
     * get all known power schedules
     * @returns {Promise}
     */
    getSchedules = () => {
        const url = `${baseUrl}/${service}/power/schedules`;
        const config = { headers: { Authorization: `Bearer ${this.getToken()}` } };
        return agent.get(url, config);
    };

    /**
     * add a power schedule
     * @param {object} data - { did, mode, type, power, start, end }
     * @returns {Promise}
     */
    postSchedule = (data) => {
        const url = `${baseUrl}/${service}/power/schedules`;
        const config = {
            headers: {
                Authorization: `Bearer ${this.getToken()}`,
                'Content-Type': 'application/json',
            },
        };
        return agent.post(url, { data }, config);
    };

    /**
     * delete a power schedule, full DTO sent in body
     * @param {object} data - PowerSchedule DTO as returned by getSchedules
     * @returns {Promise}
     */
    deleteSchedule = (data) => {
        const url = `${baseUrl}/${service}/power/schedule`;
        const config = {
            headers: {
                Authorization: `Bearer ${this.getToken()}`,
                'Content-Type': 'application/json',
            },
            data: { data },
        };
        return agent.delete(url, config);
    };
}

const powerScheduleService = new PowerScheduleService();
export default powerScheduleService;
